import React, { useRef, useState, useEffect } from "react";

const DatePickerDMY = ({ value, onChange, label, min }) => {
  const ddRef = useRef();
  const mmRef = useRef();
  const yyyyRef = useRef();
  const hiddenRef = useRef();

  const [dd, setDd] = useState("");
  const [mm, setMm] = useState("");
  const [yyyy, setYyyy] = useState("");
  const [error, setError] = useState("");

  const parse = (iso) => {
    if (!iso) return { d: "", m: "", y: "" };
    const [y, m, d] = iso.split("-");
    return { d: parseInt(d), m: parseInt(m), y };
  };

  // sync الحقول لما الـ value الجاي من برة يتغير
  useEffect(() => {
    const { d, m, y } = parse(value);
    setDd(d || "");
    setMm(m || "");
    setYyyy(y || "");
  }, [value]);

  const buildISO = (d, m, y) => {
    if (d && m && y && String(y).length === 4)
      return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    return "";
  };

  const isBeforeMin = (iso) => {
    if (!min || !iso) return false;
    return iso < min; // مقارنة نصية آمنة لأن الصيغة YYYY-MM-DD
  };

  const handleChange = (d, m, y) => {
    const iso = buildISO(d, m, y);
    if (!iso) return;

    if (isBeforeMin(iso)) {
      setError("لا يمكن اختيار تاريخ قبل اليوم");
      return;
    }
    setError("");
    onChange(iso);
  };

  return (
    <div className="d-flex flex-column gap-1">
      {label && (
        <span className="fw-semibold" style={{ fontSize: 14, color: "#333" }}>
          {label}
        </span>
      )}
      <div
        className="d-flex align-items-center"
        style={{
          width: "fit-content",
          overflow: "hidden",
          border: `1px solid ${error ? "#dc3545" : "#ddd"}`,
          borderRadius: 8,
          backgroundColor: "#fff",
          transition: "border-color 0.2s ease",
        }}
      >
        <input
          ref={ddRef}
          type="number"
          min="1"
          max="31"
          placeholder="DD"
          value={dd}
          style={inputStyle}
          onChange={(e) => {
            const v = e.target.value;
            setDd(v);
            if (v.length >= 2) mmRef.current.focus();
            handleChange(v, mm, yyyy);
          }}
        />
        <span style={{ color: "#bbb" }}>/</span>
        <input
          ref={mmRef}
          type="number"
          min="1"
          max="12"
          placeholder="MM"
          value={mm}
          style={inputStyle}
          onChange={(e) => {
            const v = e.target.value;
            setMm(v);
            if (v.length >= 2) yyyyRef.current.focus();
            handleChange(dd, v, yyyy);
          }}
        />
        <span style={{ color: "#bbb" }}>/</span>
        <input
          ref={yyyyRef}
          type="number"
          min="2024"
          max="2099"
          placeholder="YYYY"
          value={yyyy}
          style={{ ...inputStyle, width: 60 }}
          onChange={(e) => {
            const v = e.target.value;
            setYyyy(v);
            handleChange(dd, mm, v);
          }}
        />
        <button
          type="button"
          style={{
            border: "none",
            borderLeft: "1px solid #eee",
            background: "transparent",
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: 16,
          }}
          onClick={() => hiddenRef.current.showPicker()}
        >
          📅
        </button>
        <input
          ref={hiddenRef}
          type="date"
          min={min}
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: 0,
            height: 0,
          }}
          onChange={(e) => {
            const iso = e.target.value;
            if (isBeforeMin(iso)) {
              setError("لا يمكن اختيار تاريخ قبل اليوم");
              return;
            }
            setError("");
            const [yr, mo, da] = iso.split("-");
            setDd(parseInt(da));
            setMm(parseInt(mo));
            setYyyy(yr);
            onChange(iso);
          }}
        />
      </div>
      {error && <span style={{ fontSize: 12, color: "#dc3545" }}>{error}</span>}
    </div>
  );
};

const inputStyle = {
  width: 40,
  border: "none",
  outline: "none",
  textAlign: "center",
  padding: "8px 4px",
  fontSize: 14,
  color: "#333",
};

export default DatePickerDMY;
